module.exports = __webpack_public_path__ + "img/shopping-trips.507acca9.jpg";